enum PRESENCE {
    available = "available",
    in_a_call = "in_a_call",
    offline = "offline",
}
export default PRESENCE;